// Prosty zestaw utili datowych związanych z logiką biznesową planogramów
import moment from 'moment';
import { Constants } from '../Constants';

/**
 * Zwraca następny dzień roboczy (pon-pt) względem przekazanej daty.
 * Weekendy (ndz=0, sob=6) są pomijane.
 */
export function getNextBusinessDay(startDate = new Date()) {
    const base = new Date(startDate);
    const next = new Date(base);
    next.setDate(base.getDate() + 1);

    while (next.getDay() === 0 || next.getDay() === 6) {
        next.setDate(next.getDate() + 1);
    }

    return new Date(
        next.getFullYear(),
        next.getMonth(),
        next.getDate(),
        0, // hours = 0
        0, // minutes = 0
        0, // seconds = 0
        0  // milliseconds = 0
    );
}

/**
 * Konwertuje datę do formatu API (początek dnia w UTC)
 * @param {Date|string} value - data do konwersji
 * @returns {string} data w formacie API
 */
export function convertDateToApiFormat(value) {
    if (!value) return null;
    return moment(value).startOf('day').utc().format(Constants.DATE_TIME_FORMAT_GET);
}

/**
 * Konwertuje datę z formatu API do obiektu Date
 * @param {string} value - data w formacie API
 * @returns {Date} obiekt Date
 */
export function convertDateFromApiFormat(value) {
    if (!value) return null;
    return moment(value).toDate();
}

/**
 * Konwertuje datę i czas do formatu API
 * @param {Date|string} value - data do konwersji
 * @returns {string} data w formacie API
 */
export function convertDateTimeToApiFormat(value) {
    if (!value) return null;
    return moment(value).utc().seconds(0).format('YYYY-MM-DDTHH:mm:ss[Z]');
}
